import { decodeJwt } from '../../store/auth/utils'

const ACCESS_TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const IS_IMPERSONATED_KEY = 'is_impersonated'

export const getAccessToken = (): string | null => localStorage.getItem(ACCESS_TOKEN_KEY)
export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY)
export const isImpersonated = (): boolean => localStorage.getItem(IS_IMPERSONATED_KEY) === 'true'

export const setTokens = (accessToken: string, refreshToken: string): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)

    const decoded = decodeJwt(accessToken)
    
    if (decoded.impersonation?.active) {
        localStorage.setItem(IS_IMPERSONATED_KEY, 'true')
    } else {
        localStorage.removeItem(IS_IMPERSONATED_KEY)
    }
}

export const clearTokens = (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(IS_IMPERSONATED_KEY)
}
